"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDefinedGroupUserEditButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var withState_1 = require("../hocs/withState");
var api_1 = require("../api");
var i18n_1 = __importDefault(require("../i18n"));
exports.UserDefinedGroupUserEditButtons = (0, withState_1.withState)()([
    "setUserDefinedGroupsFetchRequest",
]).memoFC(function UserDefinedGroupUserEditButtons(_a) {
    var userProfileId = _a.userProfileId, userDefinedGroup = _a.userDefinedGroup, setUserDefinedGroupsFetchRequest = _a.setUserDefinedGroupsFetchRequest;
    var userDefinedGroupUser = userDefinedGroup.users[userProfileId];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Popup, { trigger: userDefinedGroupUser ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { size: "mini", icon: "heart", color: "red", onClick: function () {
                        return (0, api_1.removeUserFromUserDefinedGroup)(userDefinedGroup.id, userProfileId).then(function () {
                            return setUserDefinedGroupsFetchRequest(true);
                        });
                    } })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { size: "mini", icon: "heart", onClick: function () {
                        return (0, api_1.putUserToUserDefinedGroup)(userDefinedGroup.id, userProfileId, false).then(function () {
                            return setUserDefinedGroupsFetchRequest(true);
                        });
                    } })), content: userDefinedGroupUser ? i18n_1.default.removeUserDefinedGroupUserHelp : i18n_1.default.addUserDefinedGroupUserHelp }), !!userDefinedGroupUser && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Popup, { trigger: userDefinedGroupUser.primary ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { size: "mini", icon: "star", color: "yellow", onClick: function () {
                        return (0, api_1.putUserToUserDefinedGroup)(userDefinedGroup.id, userProfileId, false).then(function () {
                            return setUserDefinedGroupsFetchRequest(true);
                        });
                    } })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { size: "mini", icon: "star", onClick: function () {
                        return (0, api_1.putUserToUserDefinedGroup)(userDefinedGroup.id, userProfileId, true).then(function () {
                            return setUserDefinedGroupsFetchRequest(true);
                        });
                    } })), content: userDefinedGroupUser.primary
                    ? i18n_1.default.removeUserDefinedGroupPrimaryUserHelp
                    : i18n_1.default.addUserDefinedGroupPrimaryUserHelp }))] }));
});
